var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"H_copy"},React.createElement("g",null,React.createElement("polygon",{"fill":"#000","points":"433.202,65.517 400.867,235.585 243.639,235.585 261.291,146.995 384.678,146.995 401.13,65.517     57.7,65.517 40.562,146.995 162.58,146.995 91.974,501.357 191.987,501.357 221.506,346.669 227.147,318.356 384.7,318.356     350.425,501.357 443.548,501.357 526.324,65.517   "}))));
}

Logo.defaultProps = {"version":"1.1","id":"H_copy_1_","x":"0px","y":"0px","width":"566.88px","height":"566.88px","viewBox":"0 0 566.88 566.88","enableBackground":"new 0 0 566.88 566.88","xmlSpace":"preserve"};

module.exports = Logo;

Logo.default = Logo;
